import { useRef } from 'react';
import PhotosInfiniteList from './photosInfiniteList';
import FilterListPhotos from '../utils/filterLists/filterListPhotos';
import ListPageLayout from '../utils/ListPageLayout';

function PhotosPage() {
  const updateQueryFunc = useRef(null);

  function handleQuery(filters) {
    if (typeof updateQueryFunc.current === 'function') { updateQueryFunc.current(filters); }
  }

  return (
    <>
      <ListPageLayout
        title="Photos"
        tagline="Photographs preserved from the wartime period."
        sidebar={<FilterListPhotos isFiltered={handleQuery} />}
      >
        <PhotosInfiniteList filterQuery={updateQueryFunc} />
      </ListPageLayout>
    </>
  );
}

export default PhotosPage;
